import React from 'react';
import { getTranslations } from '@translations';

import styles from './styles/index.module.scss';

const Assistance = () => {
  const translations = getTranslations();
  return (
    <div className={styles.assistance}>
      <div className={styles.assistanceAvatar} />
      <p className={styles.assistanceInfo}>
        {translations('header.b2b.assistance.info.text')}
        <br />
        {translations('header.b2b.assistance.info.days')}
        <span className={styles.assistanceTel}>
          <a href={translations('header.subheader.contact.b2b.tel.link')}>
            {translations('header.b2b.assistance.tel')}
          </a>
        </span>
      </p>
    </div>
  );
};

Assistance.displayName = 'Assistance';

export default Assistance;
